module.exports = "https://cdn.dove.it/_next/static/public/assets/services/subito-serp_340x200.6e7d87f722c343f3fc7b49a9bdcf1a43.jpg";